export const MAX_UPLOAD_SIZE = 25 * 1024 * 1024;

export const MAX_UPLOAD_COUNT = 20;

export const ACCEPTED_EXTENSIONS = ['.pdf', '.docx', '.txt'];

export const ACCEPTED_EXTENSIONS_ATTR = ACCEPTED_EXTENSIONS.join(',');

export const ACCEPTED_FILE_TYPES = {
  'application/pdf': ['.pdf'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'text/plain': ['.txt'],
};

export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return `${bytes}B`;
  const kb = bytes / 1024;
  if (kb < 1024) return `${Math.round(kb)}KB`;
  const mb = kb / 1024;
  return `${mb < 10 ? mb.toFixed(1) : Math.round(mb)}MB`;
};

export const validateUploadFile = (file: File): string | null => {
  const name = file.name.toLowerCase();
  if (!ACCEPTED_EXTENSIONS.some((ext) => name.endsWith(ext))) {
    return `Unsupported file type.\nSupported types are ${ACCEPTED_EXTENSIONS.join(', ')}.`;
  }
  if (file.size > MAX_UPLOAD_SIZE) {
    return 'File exceeds the 25MB limit.';
  }
  return null;
};
